import { Route, Routes } from "react-router-dom";
import { Error404 } from "pages";
import BlankLayout from "layout/BlankLayout";
import LoginPage from "pages/login";
import LogoutPage from "pages/logout";
import LogoutProcess from "pages/logoutProcess";
// import JoinPage from "pages/join/Join";

export default function LoginRoutes() {
    return (
        <Routes>
            <Route path="/*" element={ <BlankLayout/> }>
                <Route path="login" element={ <LoginPage/> }/>
                <Route path="logout" element={ <LogoutPage/> }/>
                <Route path="logoutProcess" element={ <LogoutProcess /> }/>
                {/* <Route path="join" element={ <JoinPage /> }/> */}
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}